import { forwardRef } from "react";
import { Plus } from "lucide-react";
import { cn } from "@/utils";

interface AddButtonProps extends React.ComponentPropsWithRef<"button"> {
  label: string;
}

export const AddButton = forwardRef<HTMLButtonElement, AddButtonProps>(function AddButton(
  { label, className, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      className={cn(
        "flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-text-inverse bg-primary-hover rounded-md hover:bg-primary focus:outline-none focus:ring-2 focus:ring-ring-focus focus:ring-offset-2 transition-all hover:scale-[1.02]",
        className,
      )}
      {...props}
    >
      <Plus size={12} />
      {label}
    </button>
  );
});
